module.exports = "/_next/static/images/game-1-phone-uv-lock-2-fc4c3f2e920ee8afb77148a6a28b9a46.png";